export default __webpack_public_path__ + "static/media/humidity.d24fb01f.svg";